module.exports = __webpack_public_path__ + "img/data-energy-logo-white-crop.c5b17495.png";